module.exports = __webpack_public_path__ + "static/img/10016 (3).ce270b5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10016 (3).webp
// module id = KRDr
// module chunks = 14